import { SupportedLanguage } from '@common'
import { StaticImageData } from 'next/legacy/image'

import Step_0_ar from 'assets/images/donations/step-0_ar.png'
import Step_0_da from 'assets/images/donations/step-0_da.png'
import Step_0_de from 'assets/images/donations/step-0_de.png'
import Step_0_en from 'assets/images/donations/step-0_en.png'
import Step_0_es from 'assets/images/donations/step-0_es.png'
import Step_0_fa from 'assets/images/donations/step-0_fa.png'
import Step_0_fi from 'assets/images/donations/step-0_fi.png'
import Step_0_fr from 'assets/images/donations/step-0_fr.png'
import Step_0_he from 'assets/images/donations/step-0_he.png'
import Step_0_id from 'assets/images/donations/step-0_id.png'
import Step_0_it from 'assets/images/donations/step-0_it.png'
import Step_0_ja from 'assets/images/donations/step-0_ja.png'
import Step_0_ko from 'assets/images/donations/step-0_ko.png'
import Step_0_ms from 'assets/images/donations/step-0_ms.png'
import Step_0_nl from 'assets/images/donations/step-0_nl.png'
import Step_0_no from 'assets/images/donations/step-0_no.png'
import Step_0_pl from 'assets/images/donations/step-0_pl.png'
import Step_0_pt from 'assets/images/donations/step-0_pt.png'
import Step_0_ru from 'assets/images/donations/step-0_ru.png'
import Step_0_sv from 'assets/images/donations/step-0_sv.png'
import Step_0_th from 'assets/images/donations/step-0_th.png'
import Step_0_tr from 'assets/images/donations/step-0_tr.png'
import Step_0_vi from 'assets/images/donations/step-0_vi.png'
import Step_0_zhCN from 'assets/images/donations/step-0_zh-cn.png'
import Step_0_zhTW from 'assets/images/donations/step-0_zh-tw.png'
import Step_1_ar from 'assets/images/donations/step-1_ar.png'
import Step_1_da from 'assets/images/donations/step-1_da.png'
import Step_1_de from 'assets/images/donations/step-1_de.png'
import Step_1_en from 'assets/images/donations/step-1_en.png'
import Step_1_es from 'assets/images/donations/step-1_es.png'
import Step_1_fa from 'assets/images/donations/step-1_fa.png'
import Step_1_fi from 'assets/images/donations/step-1_fi.png'
import Step_1_fr from 'assets/images/donations/step-1_fr.png'
import Step_1_he from 'assets/images/donations/step-1_he.png'
import Step_1_id from 'assets/images/donations/step-1_id.png'
import Step_1_it from 'assets/images/donations/step-1_it.png'
import Step_1_ja from 'assets/images/donations/step-1_ja.png'
import Step_1_ko from 'assets/images/donations/step-1_ko.png'
import Step_1_ms from 'assets/images/donations/step-1_ms.png'
import Step_1_nl from 'assets/images/donations/step-1_nl.png'
import Step_1_no from 'assets/images/donations/step-1_no.png'
import Step_1_pl from 'assets/images/donations/step-1_pl.png'
import Step_1_pt from 'assets/images/donations/step-1_pt.png'
import Step_1_ru from 'assets/images/donations/step-1_ru.png'
import Step_1_sv from 'assets/images/donations/step-1_sv.png'
import Step_1_th from 'assets/images/donations/step-1_th.png'
import Step_1_tr from 'assets/images/donations/step-1_tr.png'
import Step_1_vi from 'assets/images/donations/step-1_vi.png'
import Step_1_zhCN from 'assets/images/donations/step-1_zh-cn.png'
import Step_1_zhTW from 'assets/images/donations/step-1_zh-tw.png'
import Step_2_ar from 'assets/images/donations/step-2_ar.png'
import Step_2_da from 'assets/images/donations/step-2_da.png'
import Step_2_de from 'assets/images/donations/step-2_de.png'
import Step_2_en from 'assets/images/donations/step-2_en.png'
import Step_2_es from 'assets/images/donations/step-2_es.png'
import Step_2_fa from 'assets/images/donations/step-2_fa.png'
import Step_2_fi from 'assets/images/donations/step-2_fi.png'
import Step_2_fr from 'assets/images/donations/step-2_fr.png'
import Step_2_he from 'assets/images/donations/step-2_he.png'
import Step_2_id from 'assets/images/donations/step-2_id.png'
import Step_2_it from 'assets/images/donations/step-2_it.png'
import Step_2_ja from 'assets/images/donations/step-2_ja.png'
import Step_2_ko from 'assets/images/donations/step-2_ko.png'
import Step_2_ms from 'assets/images/donations/step-2_ms.png'
import Step_2_nl from 'assets/images/donations/step-2_nl.png'
import Step_2_no from 'assets/images/donations/step-2_no.png'
import Step_2_pl from 'assets/images/donations/step-2_pl.png'
import Step_2_pt from 'assets/images/donations/step-2_pt.png'
import Step_2_ru from 'assets/images/donations/step-2_ru.png'
import Step_2_sv from 'assets/images/donations/step-2_sv.png'
import Step_2_th from 'assets/images/donations/step-2_th.png'
import Step_2_tr from 'assets/images/donations/step-2_tr.png'
import Step_2_vi from 'assets/images/donations/step-2_vi.png'
import Step_2_zhCN from 'assets/images/donations/step-2_zh-cn.png'
import Step_2_zhTW from 'assets/images/donations/step-2_zh-tw.png'

interface LocalizedDonationStep {
  [key: number]: StaticImageData
}

export const donationSteps: Record<SupportedLanguage, LocalizedDonationStep> = {
  en: {
    0: Step_0_en,
    1: Step_1_en,
    2: Step_2_en,
  },
  fi: {
    0: Step_0_fi,
    1: Step_1_fi,
    2: Step_2_fi,
  },
  de: {
    0: Step_0_de,
    1: Step_1_de,
    2: Step_2_de,
  },
  fr: {
    0: Step_0_fr,
    1: Step_1_fr,
    2: Step_2_fr,
  },
  it: {
    0: Step_0_it,
    1: Step_1_it,
    2: Step_2_it,
  },
  es: {
    0: Step_0_es,
    1: Step_1_es,
    2: Step_2_es,
  },
  nl: {
    0: Step_0_nl,
    1: Step_1_nl,
    2: Step_2_nl,
  },
  pt: {
    0: Step_0_pt,
    1: Step_1_pt,
    2: Step_2_pt,
  },
  ja: {
    0: Step_0_ja,
    1: Step_1_ja,
    2: Step_2_ja,
  },
  id: {
    0: Step_0_id,
    1: Step_1_id,
    2: Step_2_id,
  },
  'zh-cn': {
    0: Step_0_zhCN,
    1: Step_1_zhCN,
    2: Step_2_zhCN,
  },
  'zh-tw': {
    0: Step_0_zhTW,
    1: Step_1_zhTW,
    2: Step_2_zhTW,
  },
  da: {
    0: Step_0_da,
    1: Step_1_da,
    2: Step_2_da,
  },
  ko: {
    0: Step_0_ko,
    1: Step_1_ko,
    2: Step_2_ko,
  },
  ms: {
    0: Step_0_ms,
    1: Step_1_ms,
    2: Step_2_ms,
  },
  no: {
    0: Step_0_no,
    1: Step_1_no,
    2: Step_2_no,
  },
  pl: {
    0: Step_0_pl,
    1: Step_1_pl,
    2: Step_2_pl,
  },
  ru: {
    0: Step_0_ru,
    1: Step_1_ru,
    2: Step_2_ru,
  },
  sv: {
    0: Step_0_sv,
    1: Step_1_sv,
    2: Step_2_sv,
  },
  th: {
    0: Step_0_th,
    1: Step_1_th,
    2: Step_2_th,
  },
  tr: {
    0: Step_0_tr,
    1: Step_1_tr,
    2: Step_2_tr,
  },
  vi: {
    0: Step_0_vi,
    1: Step_1_vi,
    2: Step_2_vi,
  },
  ar: {
    0: Step_0_ar,
    1: Step_1_ar,
    2: Step_2_ar,
  },
  he: {
    0: Step_0_he,
    1: Step_1_he,
    2: Step_2_he,
  },
  fa: {
    0: Step_0_fa,
    1: Step_1_fa,
    2: Step_2_fa,
  },
}
